import React from 'react';
import { Formik } from 'formik';

import { DataProcessingScope } from '../../Api/Types';

import { updateAccountPartial } from '../../Api/Account/Fetch';

import Button from '../../Form/Button/Button';
import Checkbox from '../../Form/Formik/Checkbox/Checkbox';

import './SkinAnalysesDataProcessingConsent.scss';

declare global {
    interface Window {
        __GGSkinAnalysesDataProcessingConsentText: string;
    }
}

const SkinAnalysesDataProcessingConsent: React.FunctionComponent = () => {
    return (
        <div className="skin-analysis__data-processing-consent">
            <p>{window.__GGSkinAnalysesDataProcessingConsentText}</p>

            <Formik
                initialValues={{ consent: false }}
                onSubmit={() => {
                    updateAccountPartial({ dataProcessingConsents: [DataProcessingScope.SkinAnalyses] }, () =>
                        window.location.reload(),
                    );
                }}
                validate={({ consent }) => (consent ? {} : { consent: 'Sie müssen den Bedingungen zustimmen!' })}
            >
                {({ errors, touched, handleChange, handleSubmit, isSubmitting }) => (
                    <>
                        <Checkbox
                            disabled={isSubmitting}
                            errors={errors}
                            name="consent"
                            onChange={handleChange}
                            required={true}
                            touched={touched}
                            value={'1'}
                        >
                            Ich stimme den{' '}
                            <a href="/de/datenschutzhinweis" target="_blank">
                                Datenschutz-Bedingungen
                            </a>{' '}
                            zu.
                        </Checkbox>

                        <Button type="button" onClick={() => handleSubmit()} disabled={isSubmitting} primary={true}>
                            Akzeptieren
                        </Button>
                    </>
                )}
            </Formik>
        </div>
    );
};

export default SkinAnalysesDataProcessingConsent;
